import {FC, useEffect} from 'react'
import {useIntl} from 'react-intl'
import {useDispatch} from 'react-redux'
import {useParams} from 'react-router-dom'
import {useAppSelector} from '../../../../setup/redux/hooks'

import Paginator from '../../../components/Paginator'
import {
  filterSchedulerOrderDataChange,
  getSchedulerOrderList,
  selectSchedulerOrderFilter,
  selectSchedulerOrders,
} from '../redux/SchedulerRedux'
import {SchedulerOrderListFilterModel} from '../models/SchedulerOrderListFilterModel'
import {GOOGLE_DRIVE_LINK_PREFIX, SchedulerOrderStatus} from '../constants'
const SchedulerExecuteLogDetailTable: FC = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const {id} = useParams<{id: string}>()

  const orders = useAppSelector(selectSchedulerOrders)
  const filter: SchedulerOrderListFilterModel = useAppSelector(selectSchedulerOrderFilter)

  useEffect(() => {
    if (id) {
      dispatch(getSchedulerOrderList({schedulerId: id}))
    }
  }, [id])

  const handlePageChanged = (page: number) => {
    dispatch(filterSchedulerOrderDataChange({schedulerId: id, filter: {...filter, page}}))
  }

  return (
    <div className='card mb-10'>
      <div className='card-header border-0 pt-3'>
        <div className='d-flex align-items-center'>
          <div className='d-flex me-3'>
            <input
              type='text'
              className='form-control'
              placeholder={intl.formatMessage({id: 'SCHEDULER.LOGS.DETAIL.SEARCH_ORDER'})}
              value={filter.name || ''}
              onChange={(e) => {
                dispatch(
                  filterSchedulerOrderDataChange({
                    schedulerId: id,
                    filter: {...filter, name: e.target.value, page: 1},
                  })
                )
              }}
            />
          </div>
          <div className='d-flex me-3'>
            <select
              className='form-select'
              value={filter.status || ''}
              onChange={(e) =>
                dispatch(
                  filterSchedulerOrderDataChange({
                    schedulerId: id,
                    filter: {
                      ...filter,
                      status: e.target.value !== '0' ? (e.target.value as SchedulerOrderStatus) : undefined,
                      page: 1,
                    },
                  })
                )
              }
            >
              <option value={'0'}>{intl.formatMessage({id: 'SYSTEM.ALL'})}</option>
              {Object.values(SchedulerOrderStatus).map((item: any) => (
                <option key={item} value={item}>
                  {intl.formatMessage({id: 'SCHEDULER.LOGS.DETAIL.STATUS.' + item})}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className='card-body py-4'>
        <div className='table-responsive'>
          <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
            <thead>
              <tr className='fw-bold text-muted'>
                <th>{intl.formatMessage({id: 'SCHEDULER.LOGS.DETAIL.ORDER_NAME'})}</th>
                <th>{intl.formatMessage({id: 'SCHEDULER.LOGS.DETAIL.STATUS'})}</th>
                <th>{intl.formatMessage({id: 'SCHEDULER.LOGS.DETAIL.TOTAL_PHOTOS'})}</th>
                <th>{intl.formatMessage({id: 'SCHEDULER.LOGS.DETAIL.FINISHED_PHOTOS'})}</th>
                <th>{intl.formatMessage({id: 'SCHEDULER.LOGS.DETAIL.NOTE'})}</th>
                <th>{intl.formatMessage({id: 'SCHEDULER.LOGS.DETAIL.FOLDER'})}</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order.id}>
                  <td>{order.orderName}</td>
                  <td>
                    <span
                      className={`badge badge-light-${
                        order.status === SchedulerOrderStatus.DONE ? 'success' : 'danger'
                      }`}
                    >
                      {intl.formatMessage({id: `SCHEDULER.LOGS.DETAIL.STATUS.${order.status}`})}
                    </span>
                  </td>
                  <td>{order.totalImage}</td>
                  <td>{order.finishedImage}</td>
                  <td>{order.note}</td>
                  <td>
                    {order.originalFolderId && (
                      <a
                        href={GOOGLE_DRIVE_LINK_PREFIX + order.originalFolderId}
                        target='_blank'
                        rel='noreferrer'
                        className='btn btn-sm btn-light-primary'
                      >
                        <i className='bi bi-google fs-4 me-2'></i>
                        {intl.formatMessage({id: 'SCHEDULER.LOGS.DETAIL.ACCESS'})}
                      </a>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className='d-flex justify-content-end pt-10'>
          <Paginator
            currentPage={filter.page}
            totalPages={filter.pageCount || 1}
            onPageChange={handlePageChanged}
          />
        </div>
      </div>
    </div>
  )
}

export default SchedulerExecuteLogDetailTable
